module.exports = __webpack_public_path__ + "img/cloud.fcbda827.svg";